import { RPC } from 'connectors'
import { currentMainNetwork } from 'sdk'
import Web3 from 'web3'

const httpProvider = new Web3.providers.HttpProvider(RPC[currentMainNetwork])

export const web3NoAccount = new Web3(httpProvider)
